module.exports = __webpack_public_path__ + "static/media/mobile-screen.9285be9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mobile/mobile-screen.png
// module id = 276
// module chunks = 0